import produce from "immer";
import { Action } from "redux";
import { LoadingState } from "./types";

const initialState: LoadingState = [];

const loadingReducer = produce(
  (draft: LoadingState, action: Action<string>) => {
    const matches = /.*_(REQUEST|SUCCESS|FAILURE)/.exec(action.type);

    if (!matches) {
      return draft;
    }

    const requestName = action.type.replace(/_(SUCCESS|FAILURE)/, "_REQUEST");
    const [, requestState] = matches;

    if (requestState === "REQUEST") {
      if (!draft.includes(requestName)) {
        draft.push(requestName);
      }
    } else {
      for (let i = draft.length - 1; i >= 0; i--) {
        if (draft[i] === requestName) {
          draft.splice(i, 1);
        }
      }
    }
  },
  initialState
);

export default loadingReducer;
